<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-none element-without-heading" id="uncategorized">
<div class="text" id="uncategorized-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><b>MY AUTHOR MOTHER</b></p>
</div>
</div>
<div class="blockquote-container verse without-attribution">
<blockquote class="verse without-attribution">
<div class="stanza">
<p class="blockquote-content blockquote-content-verse"><i>My mother’s eyes are a deep turquoise-blue</i></p>
<p class="blockquote-content blockquote-content-verse"><i>They glisten and sparkle like crisp morning dew</i></p>
</div>
<hr class="implicit-break"/>
<div class="stanza">
<p class="blockquote-content blockquote-content-verse"><i>Her face has a beauty that is timeless and bold</i></p>
<p class="blockquote-content blockquote-content-verse"><i>She has seen many years, but she’ll never look old</i></p>
</div>
<hr class="implicit-break"/>
<div class="stanza">
<p class="blockquote-content blockquote-content-verse"><i>Her mind is a garden of childlike delight</i></p>
<p class="blockquote-content blockquote-content-verse"><i>Where magical creatures live and take flight</i></p>
</div>
<hr class="implicit-break"/>
<div class="stanza">
<p class="blockquote-content blockquote-content-verse"><i>Iridescent fairies with gossamer wings</i></p>
<p class="blockquote-content blockquote-content-verse"><i>Pearlescent unicorns and fanciful things</i></p>
</div>
<hr class="implicit-break"/>
<div class="stanza">
<p class="blockquote-content blockquote-content-verse"><i>Inhabit a world filled with fluorescent flowers</i></p>
<p class="blockquote-content blockquote-content-verse"><i>Where songbirds serenade pink bunnies for hours</i></p>
</div>
<hr class="implicit-break"/>
<div class="stanza">
<p class="blockquote-content blockquote-content-verse"><i>And sweet honey flows from gold combs in the trees</i></p>
<p class="blockquote-content blockquote-content-verse"><i>Made for the populace by purple-green bees</i></p>
</div>
<hr class="implicit-break"/>
<div class="stanza">
<p class="blockquote-content blockquote-content-verse"><i>Waterfalls rain into luminous streams</i></p>
<p class="blockquote-content blockquote-content-verse"><i>Where willow trees weep for a mermaid’s dreams</i></p>
</div>
<hr class="implicit-break"/>
<div class="stanza">
<p class="blockquote-content blockquote-content-verse"><i>All of the wonders the author’s mind can see</i></p>
<p class="blockquote-content blockquote-content-verse"><i>She records in her stories for you and me.</i></p>
</div>
<hr class="implicit-break"/>
<div class="stanza">
<p class="blockquote-content blockquote-content-verse"><i>Soon her fairytales will entrance one and all</i></p>
<p class="blockquote-content blockquote-content-verse"><i>And then she will dance at the Fairy Queen’s Ball.</i></p>
</div>
</blockquote>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?07a4cebc